exports = module.exports = require("../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sk-spinner {\n  color: #333;\n}\n\n.sk-spinner > div {\n  background-color: currentColor;\n}\n", "", {"version":3,"sources":["/app/client/node_modules/react-spinkit/css/base.css"],"names":[],"mappings":"AAAA;EACE,YAAW;CACb;;AAEA;EACE,+BAA8B;CAChC","file":"base.css","sourcesContent":[".sk-spinner {\n  color: #333;\n}\n\n.sk-spinner > div {\n  background-color: currentColor;\n}\n"],"sourceRoot":""}]);

// exports
